/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { CreateStandingOrderConfigurationRequest } from '../models/CreateStandingOrderConfigurationRequest';
import type { InitiatingAccount } from '../models/InitiatingAccount';
import type { Link } from '../models/Link';
import type { PageInfo } from '../models/PageInfo';
import type { PaginationLinks } from '../models/PaginationLinks';
import type { SignInfo } from '../models/SignInfo';
import type { StandingOrder } from '../models/StandingOrder';
import type { StandingOrderConfigType } from '../models/StandingOrderConfigType';
import type { StandingOrderConfiguration } from '../models/StandingOrderConfiguration';
import type { StandingOrderConfigurationRequest } from '../models/StandingOrderConfigurationRequest';
import type { StandingOrderRequest } from '../models/StandingOrderRequest';
import type { StandingOrdersActions } from '../models/StandingOrdersActions';

import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class StandingOrdersService {

    /**
     * Get standing order
     * Retrieves a single standing order by its external ID.
     * @returns StandingOrder Standing order resource.
     * @throws ApiError
     */
    public static getStandingOrder({
        externalAccountId,
        externalStandingOrderId,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External identifier of standing order (as described in WebApi specification).
         */
        externalStandingOrderId: string,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getStandingOrder({
        externalAccountId,
        externalStandingOrderId,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External identifier of standing order (as described in WebApi specification).
         */
        externalStandingOrderId: string,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<StandingOrder>;
    public static getStandingOrder({
        externalAccountId,
        externalStandingOrderId,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External identifier of standing order (as described in WebApi specification).
         */
        externalStandingOrderId: string,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/accounts/{externalAccountId}/standing-orders/{externalStandingOrderId}',
            path: {
                'externalAccountId': externalAccountId,
                'externalStandingOrderId': externalStandingOrderId,
            },
            query: {
                'features': features,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Edit a standing order
     * Edit existing standing order resource based on configuration data
     * @returns StandingOrder Standing order resource
     * @throws ApiError
     */
    public static putStandingOrder({
        externalAccountId,
        externalStandingOrderId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External identifier of standing order (as described in WebApi specification).
         */
        externalStandingOrderId: string,
        /**
         * Input from a standing order modification.
         */
        requestBody: StandingOrderRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static putStandingOrder({
        externalAccountId,
        externalStandingOrderId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External identifier of standing order (as described in WebApi specification).
         */
        externalStandingOrderId: string,
        /**
         * Input from a standing order modification.
         */
        requestBody: StandingOrderRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<StandingOrder>;
    public static putStandingOrder({
        externalAccountId,
        externalStandingOrderId,
        requestBody,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External identifier of standing order (as described in WebApi specification).
         */
        externalStandingOrderId: string,
        /**
         * Input from a standing order modification.
         */
        requestBody: StandingOrderRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'PUT',
            url: '/public/accounts/{externalAccountId}/standing-orders/{externalStandingOrderId}',
            path: {
                'externalAccountId': externalAccountId,
                'externalStandingOrderId': externalStandingOrderId,
            },
            query: {
                'features': features,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete a standing or sweep order identified by account id and standing order id.
     * Deletes a standing order
     * @returns any Standing order delete resource
     * @throws ApiError
     */
    public static deleteStandingOrder({
        externalAccountId,
        externalStandingOrderId,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External identifier of standing order (as described in WebApi specification).
         */
        externalStandingOrderId: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static deleteStandingOrder({
        externalAccountId,
        externalStandingOrderId,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External identifier of standing order (as described in WebApi specification).
         */
        externalStandingOrderId: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<{
        signInfo: SignInfo;
        _links?: {
            sign?: Link;
        };
    }>;
    public static deleteStandingOrder({
        externalAccountId,
        externalStandingOrderId
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External identifier of standing order (as described in WebApi specification).
         */
        externalStandingOrderId: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'DELETE',
            url: '/public/accounts/{externalAccountId}/standing-orders/{externalStandingOrderId}',
            path: {
                'externalAccountId': externalAccountId,
                'externalStandingOrderId': externalStandingOrderId,
            },
        });
    }

    /**
     * Mark cached standing or sweep orders identified by account id as expired.
     * Mark standing order cache as expired
     * @returns void
     * @throws ApiError
     */
    public static deleteStandingOrderCache({
        externalAccountId,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static deleteStandingOrderCache({
        externalAccountId,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<void>;
    public static deleteStandingOrderCache({
        externalAccountId
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'DELETE',
            url: '/public/accounts/{externalAccountId}/standing-orders/cache',
            path: {
                'externalAccountId': externalAccountId,
            },
        });
    }

    /**
     * Standing order edit configuration
     * Creates a configuration resource for editing standing order.
     * @returns StandingOrderConfiguration Standing order edit configuration.
     * @throws ApiError
     */
    public static postStandingOrderEditConfiguration({
        externalAccountId,
        externalStandingOrderId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External identifier of standing order (as described in WebApi specification).
         */
        externalStandingOrderId: string,
        /**
         * Input for a standing order edit configuration.
         */
        requestBody: StandingOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static postStandingOrderEditConfiguration({
        externalAccountId,
        externalStandingOrderId,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External identifier of standing order (as described in WebApi specification).
         */
        externalStandingOrderId: string,
        /**
         * Input for a standing order edit configuration.
         */
        requestBody: StandingOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<StandingOrderConfiguration>;
    public static postStandingOrderEditConfiguration({
        externalAccountId,
        externalStandingOrderId,
        requestBody,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External identifier of standing order (as described in WebApi specification).
         */
        externalStandingOrderId: string,
        /**
         * Input for a standing order edit configuration.
         */
        requestBody: StandingOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/accounts/{externalAccountId}/standing-orders/{externalStandingOrderId}/configuration',
            path: {
                'externalAccountId': externalAccountId,
                'externalStandingOrderId': externalStandingOrderId,
            },
            query: {
                'features': features,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * List of Standing Orders
     * Retrieves Standing Orders for productId. Standing Orders are retrieved in the same order as they come from web API.
     * @returns any A list of standing orders.
     * @throws ApiError
     */
    public static getStandingOrders({
        externalAccountId,
        page,
        size,
        cached,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Specifies the page to get, 0-based. Falls back to the default if invalid (like negative or text). A too high page number returns an empty list.
         */
        page?: number,
        /**
         * Specifies the size of a single page. When omitted, all records are returned in a signle page.
         */
        size?: number,
        /**
         * If enabled, standing orders are returned from local DB instead of WebAPI. Default: false
         */
        cached?: boolean,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getStandingOrders({
        externalAccountId,
        page,
        size,
        cached,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Specifies the page to get, 0-based. Falls back to the default if invalid (like negative or text). A too high page number returns an empty list.
         */
        page?: number,
        /**
         * Specifies the size of a single page. When omitted, all records are returned in a signle page.
         */
        size?: number,
        /**
         * If enabled, standing orders are returned from local DB instead of WebAPI. Default: false
         */
        cached?: boolean,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<({
        items?: Array<StandingOrder>;
    } & PageInfo & PaginationLinks & {
        items: Array<StandingOrder>;
        page: {
            /**
             * Total number of Labels for the user. Set to null if this number cannot be received from external API
             */
            totalElements?: number;
            /**
             * Number of items per page
             */
            size: number;
            /**
             * Unique key identification of the current page (current page index), 0-based
             */
            number: number;
            /**
             * Total number of pages
             */
            totalPages: number;
        };
        _links: {
            self: Link;
            next?: Link;
            prev?: Link;
            first: Link;
            last: Link;
        };
    })>;
    public static getStandingOrders({
        externalAccountId,
        page,
        size,
        cached,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Specifies the page to get, 0-based. Falls back to the default if invalid (like negative or text). A too high page number returns an empty list.
         */
        page?: number,
        /**
         * Specifies the size of a single page. When omitted, all records are returned in a signle page.
         */
        size?: number,
        /**
         * If enabled, standing orders are returned from local DB instead of WebAPI.
         */
        cached?: boolean,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/accounts/{externalAccountId}/standing-orders',
            path: {
                'externalAccountId': externalAccountId,
            },
            query: {
                'page': page,
                'size': size,
                'cached': cached,
                'features': features,
            },
        });
    }

    /**
     * Create a standing order
     * Create a standing order resource based on configuration data
     * @returns StandingOrder Standing order resource
     * @throws ApiError
     */
    public static postStandingOrder({
        externalAccountId,
        type,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        type: StandingOrderConfigType,
        /**
         * Input from a standing order creation.
         */
        requestBody: StandingOrderRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static postStandingOrder({
        externalAccountId,
        type,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        type: StandingOrderConfigType,
        /**
         * Input from a standing order creation.
         */
        requestBody: StandingOrderRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<StandingOrder>;
    public static postStandingOrder({
        externalAccountId,
        type,
        requestBody,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        type: StandingOrderConfigType,
        /**
         * Input from a standing order creation.
         */
        requestBody: StandingOrderRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/accounts/{externalAccountId}/standing-orders',
            path: {
                'externalAccountId': externalAccountId,
            },
            query: {
                'type': type,
                'features': features,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Standing and sweep orders actions
     * Available actions for standing and sweep orders.
     * @returns any Links with respective actions for standing/sweep orders.
     * @throws ApiError
     */
    public static getStandingOrdersActions({
        externalAccountId,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getStandingOrdersActions({
        externalAccountId,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<{
        initiatingAccount: InitiatingAccount;
        _links?: {
            addressBookAccounts?: Link;
            addressBookAccountsSearch?: Link;
            addressBookTemplates?: Link;
            collection?: Link;
        };
        standingOrders?: StandingOrdersActions;
        sweepOrders?: StandingOrdersActions;
    }>;
    public static getStandingOrdersActions({
        externalAccountId,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/accounts/{externalAccountId}/standing-orders/actions',
            path: {
                'externalAccountId': externalAccountId,
            },
            query: {
                'features': features,
            },
        });
    }

    /**
     * Standing order configuration
     * Creates a configuration resource for creating a new standing order.
     * @returns StandingOrderConfiguration A standing order create configuration.
     * @throws ApiError
     */
    public static postStandingOrderCreateConfiguration({
        externalAccountId,
        type,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        type: StandingOrderConfigType,
        /**
         * Input for a standing order create configuration.
         */
        requestBody: CreateStandingOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static postStandingOrderCreateConfiguration({
        externalAccountId,
        type,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        type: StandingOrderConfigType,
        /**
         * Input for a standing order create configuration.
         */
        requestBody: CreateStandingOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<StandingOrderConfiguration>;
    public static postStandingOrderCreateConfiguration({
        externalAccountId,
        type,
        requestBody,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        type: StandingOrderConfigType,
        /**
         * Input for a standing order create configuration.
         */
        requestBody: CreateStandingOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/accounts/{externalAccountId}/standing-orders/configuration',
            path: {
                'externalAccountId': externalAccountId,
            },
            query: {
                'type': type,
                'features': features,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Standing order from template configuration
     * Creates a configuration resource for creating a new standing order from a template.
     * @returns StandingOrderConfiguration A standing order configuration.
     * @throws ApiError
     */
    public static postStandingOrderCreateConfigurationFromTemplate({
        externalAccountId,
        externalTemplateId,
        type,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External template identifier (as described in WebApi specification).
         */
        externalTemplateId: string,
        type: StandingOrderConfigType,
        /**
         * Input for a standing order configuration.
         */
        requestBody: StandingOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static postStandingOrderCreateConfigurationFromTemplate({
        externalAccountId,
        externalTemplateId,
        type,
        requestBody,
        features,
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External template identifier (as described in WebApi specification).
         */
        externalTemplateId: string,
        type: StandingOrderConfigType,
        /**
         * Input for a standing order configuration.
         */
        requestBody: StandingOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<StandingOrderConfiguration>;
    public static postStandingOrderCreateConfigurationFromTemplate({
        externalAccountId,
        externalTemplateId,
        type,
        requestBody,
        features
    }: {
        /**
         * External account identifier (as described in WebApi specification).
         */
        externalAccountId: string,
        /**
         * External template identifier (as described in WebApi specification).
         */
        externalTemplateId: string,
        type: StandingOrderConfigType,
        /**
         * Input for a standing order configuration.
         */
        requestBody: StandingOrderConfigurationRequest,
        /**
         * Comma-separated list of case-insensitive feature flag keys to enable for this request.
         * Unknown or invalid keys are silently ignored.
         *
         * Available feature flags:
         * - `payments.isoAddressPaymentConfig` - Enables usage of new ISO-20022 address fields in payments
         * - `payments.legalEntityIdentifier` - Enables field Legal Entity Identifier in payment orders and standing orders
         * - `payments.verificationOfPayee` - Enables verification of payee in payment orders
         * - `junior.profileContainsJuniorFlag` - A flag appended based on whether the profile contains the junior flag
         * - `payments.transferTime` - Enables usage of transfer time in payment orders and standing orders
         * - `pay.supCountry` - Enables usage of COUNTRIES config field type
         * - `junior.newTakeOutLogic` - Enable new take out handling for junior accounts
         * - `pay.ipsReload` - Enable config reload for IPS configuration
         * - `pay.isoSto` - Enables usage of ISO-20022 address fields in standing orders
         *
         */
        features?: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/accounts/{externalAccountId}/templates/{externalTemplateId}/standing-orders/configuration',
            path: {
                'externalAccountId': externalAccountId,
                'externalTemplateId': externalTemplateId,
            },
            query: {
                'type': type,
                'features': features,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
